import React from 'react';
import {classes, style} from './dopp-layout-background-media.st.css';
import {DoppePageBackgroundView} from '../../../doppe-page-background-view/doppe-page-background-view';

export const DoppLayoutBackgroundMedia = React.memo(function DoppLayoutBackgroundMedia(props: DoppLayoutBackgroundMedia.Props) {
    const {
        className,
        ...restProps
    } = props;

    return (
        <DoppePageBackgroundView
            {...restProps}
            className={style(classes.root, {}, className)}
        />
    )
});

export namespace DoppLayoutBackgroundMedia {

    export interface Props extends DoppePageBackgroundView.Props {
    }
}